import { useQuery } from '@tanstack/react-query';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useCaseReports(sessionId: string | undefined) {
  return useQuery({
    queryKey: sessionsKeys.operation('case-reports', sessionId ?? ''),
    queryFn: () => {
      if (!sessionId) throw new Error('missing id');
      return sessionsService.listCaseReports(sessionId);
    },
    enabled: Boolean(sessionId),
  });
}
